'use client';
'use strict';

var classes = {"calendarHeader":"m-730a79ed","calendarHeaderLevel":"m-f6645d97","calendarHeaderControl":"m-2351eeb0","calendarHeaderControlIcon":"m-367dc749"};

module.exports = classes;
//# sourceMappingURL=CalendarHeader.module.css.cjs.map
